module.exports = __webpack_public_path__ + "static/media/warning_circle.380f5682.svg";